export default {"src":"/_next/static/media/ikon-pass.c7c40678.svg","height":63,"width":136,"blurWidth":0,"blurHeight":0};